// extracted by mini-css-extract-plugin
export var logounit = "LogoUnit-module--logounit--2K6sD";
export var logo = "LogoUnit-module--logo--25CSo";
export var title = "LogoUnit-module--title--25pPD";
export var description = "LogoUnit-module--description--xy7UQ";
export var minimal = "LogoUnit-module--minimal--2YkyT LogoUnit-module--logounit--2K6sD";